export default __webpack_public_path__ + "static/media/info.37a925bc.svg";